export function SetViewPreferenceForView(key: string, value: boolean) {
    localStorage.setItem(`preference:${key}`, value ? "true" : "false");
}

export function GetViewPreferenceForView(key: string): boolean | null {
    const value = localStorage.getItem(`preference:${key}`);
    return value === null ? null : value === "true";
}
